import React from 'react';
import {ArrowStrokeLeft} from '@epic-ui/icons';
import Button, {ButtonProps} from './Button';
import {useRouteHistory} from '../../../hooks';

export interface BackButtonProps extends ButtonProps {
    ignorePaths?: string[];
}

const BackButton: React.FC<BackButtonProps> = ({to, ignorePaths, ...rest}) => {
    const route = useRouteHistory(ignorePaths);
    const redirectTo = to || route.from;
    return (
        <Button
            showIconOnMobile
            to={redirectTo}
            color="secondary"
            startIcon={<ArrowStrokeLeft />}
            {...rest}
        />
    );
};

export default BackButton;
